module.exports = __webpack_public_path__ + "static/media/OurProduct-TealBlock.299f8e54.svg";